import React from "react";
import { Container, Typography } from "@material-ui/core";

export default () => {
  return (
    <Container>
      <Typography>User Details</Typography>
    </Container>
  );
};
